import { FC } from "react";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { UploadFile } from "@ryde/controls";
import {
  BOOKING_UPLOAD_FORM_FIELDS,
  errors,
  getFileExtension,
  Log,
  SUPPORTED_CSV_FILE_EXTENSIONS,
} from "@ryde/shared";

import { DrawerFormWrapperStyled } from "../../drawer";
import {
  BulkBookingHeaderStyled,
  BulkConflictsSection,
  BulkCreateBookingsFormBlockStyled,
  BulkUploadCreateFieldsSection,
  useBulkBookingUploadForm,
} from "../bulk-bookings-components";

export const BulkUploadBookingsForm: FC = () => {
  const { t } = useTranslation();
  const { onFileChange, onFileClear } = useBulkBookingUploadForm();
  const { watch } = useFormContext();

  const file = watch(BOOKING_UPLOAD_FORM_FIELDS.file);

  const handleChange = async (
    event: React.ChangeEvent<HTMLInputElement>,
  ): Promise<void> => {
    const fileFromEvent = event.target.files?.[0];

    if (!fileFromEvent) {
      Log.debug("No file selected");
      return;
    }

    // Extension-based, like the generic upload: Excel-authored CSVs reach the browser with
    // an Excel MIME type, and a MIME-only check rejects them before parsing.
    if (
      !SUPPORTED_CSV_FILE_EXTENSIONS.includes(
        getFileExtension(fileFromEvent.name),
      )
    ) {
      Log.warnAndToast(t(errors.common.invalidFileType));
      return;
    }

    onFileChange(fileFromEvent);
  };

  return (
    <DrawerFormWrapperStyled>
      <BulkBookingHeaderStyled>
        <BulkCreateBookingsFormBlockStyled>
          <UploadFile
            accept=".csv"
            onChange={handleChange}
            onClear={onFileClear}
            file={file}
          />
          <BulkUploadCreateFieldsSection />
        </BulkCreateBookingsFormBlockStyled>
      </BulkBookingHeaderStyled>

      <BulkConflictsSection />
    </DrawerFormWrapperStyled>
  );
};
